import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

const headerCellClassName =
  'h-12 px-2 text-left text-xs font-semibold text-text-secondary first:pl-3 last:pr-3 2xl:px-4 2xl:first:pl-5 2xl:last:pr-5';

const tableColumns = [
  { key: 'tenantSubTenant', className: 'w-[19%] 2xl:w-[29%]' },
  { key: 'primaryColor', className: 'w-[21%] 2xl:w-[18%]' },
  { key: 'secondaryColor', className: 'w-[21%] 2xl:w-[18%]' },
  { key: 'icon', className: 'w-[24%] 2xl:w-[18%]' },
  { key: 'actions', className: 'w-[15%] text-right 2xl:w-[17%]' },
] as const;

export const CustomerIdentityTableHeader = () => {
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow className="border-b border-background-darker bg-white hover:bg-white">
        {tableColumns.map((column) => (
          <TableHead key={column.key} className={cn(headerCellClassName, column.className)}>
            {t(column.key)}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
};
